import { useCallback, useMemo } from "react";
import datetime from "config/datetime";
import { VELOCITY_ONBOARDING_EXPIRATION_DATE } from "config/onboarding";
import useOnBoarding from "providers/OnBoardingProvider/useOnBoarding";
import type { LocalStorageKey } from "providers/OnBoardingProvider/OnBoardingProvider";

/**
 * Visibility of a velocity-based 1RM onboarding element (modal, hotspot, tooltip).
 * Shown until the user dismisses it, and never after `VELOCITY_ONBOARDING_EXPIRATION_DATE`.
 */
function useVelocityOnBoarding(key: LocalStorageKey) {
  const { getOpen, setOpen } = useOnBoarding();

  const isExpired = datetime().isAfter(VELOCITY_ONBOARDING_EXPIRATION_DATE);
  const open = useMemo(() => !isExpired && getOpen(key, true), [getOpen, isExpired, key]);

  const dismiss = useCallback(() => setOpen(key, false), [key, setOpen]);

  return { open, dismiss };
}

export default useVelocityOnBoarding;
